import {ValueObject} from '@s-ui/domain'

export class RemoteSeoContentSeoValueObject extends ValueObject {
  #title
  #description
  #h1

  constructor({title, description, h1}) {
    super()
    RemoteSeoContentSeoValueObject.validate({title, description, h1})
    this.#title = title
    this.#description = description
    this.#h1 = h1
  }

  static validate({title, description, h1}) {
    if (title !== null && typeof title !== 'string') {
      throw new Error('[RemoteSeoContentSeoValueObject#validate] title must be a string or null')
    }
    if (description !== null && typeof description !== 'string') {
      throw new Error('[RemoteSeoContentSeoValueObject#validate] description must be a string or null')
    }
    if (h1 !== null && typeof h1 !== 'string') {
      throw new Error('[RemoteSeoContentSeoValueObject#validate] h1 must be a string or null')
    }
  }

  static createFromPrimitives({title, description, h1} = {}) {
    return new RemoteSeoContentSeoValueObject({
      title: title || null,
      description: description || null,
      h1: h1 || null
    })
  }

  get title() {
    return this.#title
  }

  get description() {
    return this.#description
  }

  get h1() {
    return this.#h1
  }

  isComplete() {
    return Boolean(this.#title && this.#description && this.#h1)
  }

  toPrimitives() {
    return {
      title: this.#title,
      description: this.#description,
      h1: this.#h1
    }
  }

  toJSON() {
    return this.toPrimitives()
  }
}
